// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'; 
import 'element-ui/lib/theme-chalk/display.css';
import '../static/css/my_style.css'
import '../static/css/global.css'
// 富文本样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import adminApi from './util/common.js';


Vue.config.devtools = true;

/*引入Element UI插件*/
Vue.use(ElementUI);

/*引入资源请求插件*/
import VueResource from 'vue-resource'

/*使用VueResource插件*/
Vue.use(VueResource)

//定义全局变量
Vue.prototype.adminApi = adminApi;
  
import axios from 'axios';

import Print from '@/plugs/print'
Vue.use(Print)

// import Lodop from '@/plugs//LodopFuncs'
// Vue.use(Lodop)



// 请求基准路径
// axios.defaults.baseURL = 'https://zxx.xiaocx.org/Admin';
axios.defaults.baseURL = adminApi.admin_api;

// 请求拦截（配置发送请求的信息）-------------------
axios.interceptors.request.use(function (config) {
	// 处理请求之前的配置
	const token = sessionStorage.getItem('access-token');
	const user_id = sessionStorage.getItem('user_id');
	const project_ids = sessionStorage.getItem('project_ids');

	var is_login = config.url.indexOf('login') == -1 ? false : true;

	if (!is_login) {
		if (config.method == 'post') {
			config.data.token = token;
			config.data.user_id = user_id;
			// config.data.project_ids = project_ids;
		}
		if (config.method == 'get') {
			config.params.token = token;
			config.data.user_id = user_id;
			// config.data.project_ids = project_ids;
		}
	}
	return config;

}, function (error) {
	// 请求失败的处理
	return Promise.reject(error);
});

// 响应拦截（配置请求回来的信息）-------------------
axios.interceptors.response.use(function (response) {
	if (response.data) {
		return response.data
	} else {
		return response;
	}
}, function (error) {
 
	// 处理响应失败
	if (error.response.data) {
		return Promise.reject(error.response.data);
	}
});
Vue.prototype.axios = axios;




// 路由守卫
router.beforeEach((to, from, next) => {
	if (to.path === '/Login') return next()
	const token = sessionStorage.getItem('access-token')

	if (!token) return next('/Login')
	next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js